import React, {Component} from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'

import {Card, Col, Row, Table} from 'antd'
import Request from '../../../../request'
import {connect} from 'react-redux'

let countryId = null

class CountryFact extends Component {
    state = {obj: {uniArr: []}}


    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        countryId = searchParams.get('id')
        this.apiRequest(countryId)
    }

    apiRequest = async _id => {
        let data = await Request.getCountryFact(_id)
        if (data) {
            console.table(data.uniArr)
            this.setState({obj: data})
        }
    }

    render() {
        const columns = [
            {
                title: 'University Name',
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName'
            }
        ]
        return (
            <PageHeaderWrapper title={'University'}>
                <Card bordered={true}>
                    <Row>
                        <Col span={12}>
                            <div/>
                        </Col>
                        <Col span={12}>
                            <Table columns={columns} dataSource={this.state.obj.uniArr}/>
                        </Col>
                    </Row>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CountryFact)
